export default data => ({
  content: {
    ...data.content,
    is_root: data.type === 'add_archipelago',
    type: `sequence`,
  },
});
